module.exports = __webpack_public_path__ + "img/perforaciones2_4-3_1536.3e5d92a4.jpg";